<template>
  <div>
    <b-card title="İçerik Görseli">
      <b-img
        v-if="dataItem.image_content"
        :src="imageUrl + '/media/fairs/' + dataItem.image_content"
        thumbnail
        center
      />
      <div class="text-center mt-1">
        <b-button
          variant="primary"
          @click="setModal('fairs')"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
      </div>
    </b-card>
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      @uploadImage="setUploadImage"
    />
  </div>
</template>
<script>
import { BCard, BImg, BButton } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'ImageCard',
  components: {
    BCard,
    BImg,
    BButton,
    CropperImage,
  },
  data() {
    return {
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      },
      required,
      imageUrl: this.$store.state.app.baseURL,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['fairs/dataItem']
    },
  },
  methods: {
    setModal(type) {
      if (type === 'fairs') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'fairs-image.jpg',
          folder: 'fairs',
          ratio: 4 / 3,
          type: 'fairs',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      this.dataItem.image_content = item.image
      this.dataItem.content_thumb = item.thumb
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
